import create from "zustand";

const initialState = {
  show: false,
  theme: "primary",
  message: "",
};

export const useToastStore = create((set) => {
  const hideToast = () => {
    set(() => ({
      ...initialState,
    }));
  };
  return {
    ...initialState,
    hideToast,
    showToast: ({
      theme,
      message,
      autoClose = false,
      timeout = 3000,
      hidePrevious = true,
    }) => {
      if (message) {
        hidePrevious && hideToast();
        setTimeout(() => {
          set((state) => ({
            ...state,
            theme,
            message,
            show: true,
          }));
          if (autoClose) {
            setTimeout(hideToast, timeout);
          }
        }, 100);
      }
    },
  };
});
